import React from "react";
import { Err404 } from "../pages/Err404";
import { routes } from "./Routes";
import App from "../App";
import GamesPage from "../pages/Games";
import Lobby from "../pages/Lobby";
import GameModal from "../components/GameModal";
import OffersPage from "../pages/OffersPage";
import FavoritesPage from "../pages/FavoritesPage";
import { GeneralPage } from "../pages/GeneralPage";

export const appRoutes = () => [
    {
        path: routes.root,
        element: <App />,
        errorElement: <Err404 />,
        children: [
            {
                index: true,
                element: <Lobby />,
            },
            {
                path: `${routes.pages.games}/hot`,
                element: <GamesPage />,
            },
            {
                path: `${routes.pages.games}/new`,
                element: <GamesPage />,
            },
            {
                path: `${routes.pages.games}/:slug?`,
                element: <GamesPage />,
            },
            {
                path: `${routes.pages.game}`,
                element: <GameModal />,
            },
            {
                path: `${routes.pages.offers}`,
                element: <OffersPage />,
            },
            {
                path: `${routes.pages.favorites}`,
                element: <FavoritesPage />,
            },
            {
                path: "*",
                elemement: <GeneralPage />,
            },
        ],
    },
];
